import { useEffect, useState } from "react";
import SurveyResultsChart from "../../../core/graph/SurveyResultsChart";

interface Props {
    title: string;
    lista: any;
}
export const ProofResponseGraph = ({ lista, title }: Props) => {


    const [data, setData] = useState<any>();

    useEffect(() => {
        if (lista && lista.length > 0) {
            let temp: any = [];

            lista.forEach(element => {
                let value = element.DataBeanProperties.ValueOption;

                if (value === 'true') value = 'SI';
                if (value === 'false') value = 'NO';

                temp.push({
                    value: value,
                    count: parseInt(element.DataBeanProperties.Cantidad),
                });
            });

            setData(temp);
        } else {
            setData([]);
        }
    }, [lista]);

    return (
        <div className="row">
            <div className="col-md-12">
                {/* <h5><SpanRender value={title}/></h5> */}
                <SurveyResultsChart data={data} showPercentInLegend={true} title={title} />
            </div>
            <div className="col-md-12">
                {/* <PrintJson json={data}/> */}
            </div>
        </div>
    )
}